import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import axios from '../../axios';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Alert,
    InputAdornment
} from '@mui/material';
import { Search, CreditCard, Person, Business, CheckCircle, Cancel } from '@mui/icons-material';
import Spinner from 'components/Spinner';
import PageHeader from 'components/PageHeader';

const useStyles = createUseStyles({
    container: {
        padding: '32px',
        backgroundColor: '#f8fafc',
        minHeight: '100vh'
    },
    header: {
        marginBottom: '32px'
    },
    title: {
        color: '#64748b',
        fontSize: '24px',
        fontWeight: '600',
        marginBottom: '8px'
    },
    subtitle: {
        color: '#64748b',
        fontSize: '16px',
        fontWeight: '400',
        margin: 0
    },
    statsGrid: {
        marginBottom: '20px'
    },
    statCard: {
        backgroundColor: '#ffffffff',
        // background: 'linear-gradient(135deg, #34d3998c 0%, #10b98183 100%)',
        borderRadius: '16px',
        border: '2px solid #10b981',
        paddingInline: '24px',
        paddingTop: '24px',
        paddingBottom: '30px',
        color: '#1e293b',
        // boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 12px -1px rgba(0, 0, 0, 0.1)',
            borderColor: '#059669',
            backgroundColor: '#f0fdf4'
        }
    },
    statCardSpecial: {
        backgroundColor: '#ffffff',
        border: '3px solid #059669',
        boxShadow: '0 6px 12px -2px rgba(0, 0, 0, 0.2)',
        '&:hover': {
            borderColor: '#047857',
            backgroundColor: '#ecfdf5',
            boxShadow: '0 12px 20px -4px rgba(0, 0, 0, 0.3)',
            transform: 'translateY(-4px)'
        }
    },
    statCardValue: {
        // backgroundColor: '#ffffff',
        background: 'linear-gradient(135deg, #34d399 0%, #10b981 100%)',

        border: '3px solid #10b981',
        boxShadow: '0 6px 12px -2px rgba(16, 185, 129, 0.2)',
        '&:hover': {
            // borderColor: '#059669',
            backgroundColor: '#f0fdf4',
            boxShadow: '0 12px 20px -4px rgba(16, 185, 129, 0.3)',
            transform: 'translateY(-4px)'
        }
    },
    statCardTotal: {
        backgroundColor: '#ffffff',
        border: '3px solid #047857',
        boxShadow: '0 6px 12px -2px rgba(4, 120, 87, 0.25)',
        '&:hover': {
            borderColor: '#065f46',
            backgroundColor: '#ecfdf5',
            boxShadow: '0 12px 20px -4px rgba(4, 120, 87, 0.35)',
            transform: 'translateY(-4px)'
        }
    },
    statTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#059669',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center'
    },
    statValue: {
        fontSize: '40px',
        fontWeight: '700',
        textAlign: 'center',
        color: '#1e293b'
    },
    searchSection: {
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        marginBottom: '24px'
    },
    searchTitle: {
        color: '#1e293b',
        fontSize: '20px',
        fontWeight: '600',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    searchField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            '&:hover fieldset': {
                borderColor: '#059669'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#059669'
            }
        }
    },
    cardDetails: {
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        marginBottom: '24px',
        border: '2px solid #10b981'
    },
    cardDetailsTitle: {
        color: '#059669',
        fontSize: '20px',
        fontWeight: '600',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    detailItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 0',
        borderBottom: '1px solid #e2e8f0',
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    detailLabel: {
        color: '#64748b',
        fontSize: '14px',
        fontWeight: '500'
    },
    detailValue: {
        color: '#1e293b',
        fontSize: '14px',
        fontWeight: '600'
    },
    clickableValue: {
        color: '#059669',
        cursor: 'pointer',
        '&:hover': {
            color: '#047857',
            textDecoration: 'underline'
        }
    },
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: '16px',
            padding: '8px'
        }
    },
    dialogTitle: {
        color: '#1e293b',
        fontSize: '20px',
        fontWeight: '600',
        padding: '24px 24px 16px 24px'
    },
    errorText: {
        color: '#dc2626',
        fontSize: '14px',
        fontWeight: '500',
        marginTop: '8px',
        padding: '12px',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '8px'
    }
});

export default function ScratchCardProducts() {
    const [Available, SetAvailable] = useState(-1);
    const [Unavailable, SetUnvailable] = useState(-1);
    const [Available20, SetAvailable20] = useState(-1);
    const [Available10, SetAvailable10] = useState(-1);
    const [Available50, SetAvailable50] = useState(-1);
    const [Available2, SetAvailable2] = useState(-1);
    const [Available1, SetAvailable1] = useState(-1);
    const [Available_5, SetAvailable_5] = useState(-1);
    const [Available5, SetAvailable5] = useState(-1);
    const [currentCard, SetCurrentCard] = useState({});
    const [searchWord, setSearchWord] = useState('');
    const [error, setError] = useState('');
    const [fetchCard, setFetchCard] = useState(false);
    const [openAdmin, setOpenAdmin] = React.useState(false);
    const [type, setTypeID] = React.useState('');
    const [admin, setAdmin] = React.useState({});
    const [adminLoader, setAdminLoader] = React.useState(false);

    useEffect(() => {
        async function fetchData() {
            await getAvailablecards();
            getUnAvailablecards();
            featuresSpacificCardCount('50000');
            featuresSpacificCardCount('20000');
            featuresSpacificCardCount('10000');
            featuresSpacificCardCount('5000');
            featuresSpacificCardCount('2000');
            featuresSpacificCardCount('1000');
            featuresSpacificCardCount('500');
        }
        fetchData();
    }, []);

    const getAvailablecards = () => {
        axios
            .post(`/cards/available`, { cardAmount: '' })
            .then((response) => {
                SetAvailable(response.data.count[0].count);
            })
            .catch((error) => {
                SetAvailable('failed');
            });
    };
    const getUnAvailablecards = () => {
        axios
            .post(`/cards/unavailable`, { cardAmount: '' })
            .then((response) => {
                SetUnvailable(response.data.count[0].count);
            })
            .catch((error) => {
                SetUnvailable('failed');
            });
    };
    const featuresSpacificCardCount = (amount) => {
        axios
            .post(`/cards/available`, { cardAmount: amount })
            .then((response) => {
                if (amount === '20000') {
                    SetAvailable20(response.data.count);
                }
                if (amount === '50000') {
                    SetAvailable50(response.data.count);
                }
                if (amount === '10000') {
                    SetAvailable10(response.data.count);
                }
                if (amount === '2000') {
                    SetAvailable2(response.data.count);
                }
                if (amount === '5000') {
                    SetAvailable5(response.data.count);
                }
                if (amount === '1000') {
                    SetAvailable1(response.data.count);
                }
                if (amount === '500') {
                    SetAvailable_5(response.data.count);
                }
            })
            .catch((error) => {
                if (amount === '20000') {
                    SetAvailable20('failed');
                }
                if (amount === '50000') {
                    SetAvailable50('failed');
                }
                if (amount === '10000') {
                    SetAvailable10('failed');
                }
                if (amount === '2000') {
                    SetAvailable2('failed');
                }
                if (amount === '5000') {
                    SetAvailable5('failed');
                }
                if (amount === '1000') {
                    SetAvailable1('failed');
                }
                if (amount === '500') {
                    SetAvailable_5('failed');
                }
            });
    };
    const getSearchCard = () => {
        if (searchWord === '') {
            return;
        }
        setFetchCard(true);
        axios
            .get(`/cards/${searchWord}`)
            .then((response) => {
                console.log(response);
                SetCurrentCard({ ...response.data.data });
                setFetchCard(false);
            })
            .catch((error) => {
                setError('failed to that card');
                SetCurrentCard({});
                setFetchCard(false);
            });
    };
    const fetchAdmin = (id, link) => {
        setAdminLoader(true);
        axios
            .get(`/${link}/${id}`)
            .then((response) => {
                console.log(response.data.data);
                setAdmin(response.data.data);
                setAdminLoader(false);
            })
            .catch((error) => {
                alert('failed to User, please try again later');
                setOpenAdmin(false);
                setAdminLoader(false);
            });
    };

    const handleUserView = (id) => {
        setTypeID('admin');
        fetchAdmin(id, 'admin');
        setOpenAdmin(true);
    };

    const handleFarmerView = (id) => {
        fetchAdmin(id, 'farmer');
        setTypeID('farmer');
        setOpenAdmin(true);
    };

    const handlepackagesClose = () => {
        setOpenAdmin(false);
    };

    const classes = useStyles();

    return (
        <div>
            {/* Header Section */}
            <PageHeader
                title='Scratch Card Management'
                subtitle='Monitor and manage scratch card inventory and usage'
                variant='gradient'
            />

            <div>
                {/* Statistics Cards */}
                <Grid container spacing={3} className={classes.statsGrid}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={`${classes.statCard} ${classes.statCardValue}`}>
                            <Typography style={{ color: 'white' }} className={classes.statTitle}>
                                <CreditCard sx={{ fontSize: 20, marginRight: 1, color: 'white' }} />
                                Unused Cards
                            </Typography>
                            <Typography style={{ color: 'white' }} className={classes.statValue}>
                                {Available === -1 ? <Spinner /> : Available}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={`${classes.statCard} ${classes.statCardValue}`}>
                            <Typography style={{ color: 'white' }} className={classes.statTitle}>
                                <CheckCircle
                                    sx={{ fontSize: 20, marginRight: 1, color: 'white' }}
                                />
                                Used Cards
                            </Typography>
                            <Typography style={{ color: 'white' }} className={classes.statValue}>
                                {Unavailable === -1 ? <Spinner /> : Unavailable}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={`${classes.statCard} ${classes.statCardValue}`}>
                            <Typography style={{ color: 'white' }} className={classes.statTitle}>
                                Total Cards
                            </Typography>
                            <Typography style={{ color: 'white' }} className={classes.statValue}>
                                {Available === -1 || Unavailable === -1 ? (
                                    <Spinner />
                                ) : (
                                    Available + Unavailable
                                )}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Card Value Breakdown */}
                <Grid container spacing={3} className={classes.statsGrid}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 50,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available50 === -1 ? <Spinner /> : Available50}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 20,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available20 === -1 ? <Spinner /> : Available20}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 10,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available10 === -1 ? <Spinner /> : Available10}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 5,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available5 === -1 ? <Spinner /> : Available5}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Lower Value Cards */}
                <Grid container spacing={3} className={classes.statsGrid}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 2,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available2 === -1 ? <Spinner /> : Available2}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 1,000 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available1 === -1 ? <Spinner /> : Available1}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box className={classes.statCard}>
                            <Typography className={classes.statTitle}>UGX 500 Cards</Typography>
                            <Typography className={classes.statValue}>
                                {Available_5 === -1 ? <Spinner /> : Available_5}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Search Section */}
                <Box className={classes.searchSection}>
                    <Typography style={{ marginBottom: '20px' }} className={classes.searchTitle}>
                        <Search />
                        Search Card
                    </Typography>
                    <TextField
                        fullWidth
                        className={classes.searchField}
                        label='Card Number'
                        placeholder='Enter exact card number'
                        variant='outlined'
                        value={searchWord}
                        onChange={(e) => {
                            setSearchWord(e.target.value);
                            setError('');
                            if (e.target.value === '') {
                                SetCurrentCard({});
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <CreditCard sx={{ color: '#64748b' }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <Button
                                        variant='contained'
                                        onClick={getSearchCard}
                                        disabled={fetchCard}
                                        sx={{
                                            backgroundColor: '#059669',
                                            borderRadius: '8px',
                                            '&:hover': {
                                                backgroundColor: '#047857'
                                            }
                                        }}
                                    >
                                        {fetchCard ? <Spinner /> : 'Search'}
                                    </Button>
                                </InputAdornment>
                            )
                        }}
                    />
                    {error && (
                        <Alert severity='error' sx={{ mt: 2, borderRadius: '12px' }}>
                            {error}
                        </Alert>
                    )}
                </Box>

                {/* Card Details */}
                {Object.keys(currentCard).length > 0 && (
                    <Box className={classes.cardDetails}>
                        <Typography className={classes.cardDetailsTitle}>
                            <CheckCircle />
                            Card Details
                        </Typography>
                        <Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>Amount</Typography>
                                <Typography className={classes.detailValue}>
                                    {new Intl.NumberFormat('en-UG', {
                                        style: 'currency',
                                        currency: 'UGX'
                                    }).format(currentCard.amount)}
                                </Typography>
                            </Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>Card Number</Typography>
                                <Typography className={classes.detailValue}>
                                    {currentCard.cardNumber}
                                </Typography>
                            </Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>Created At</Typography>
                                <Typography className={classes.detailValue}>
                                    {new Date(currentCard.createdAt).toLocaleString('en-US')}
                                </Typography>
                            </Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>
                                    Used By (Farmer)
                                </Typography>
                                <Typography
                                    className={`${classes.detailValue} ${classes.clickableValue}`}
                                    onClick={() => handleFarmerView(currentCard.farmer)}
                                >
                                    <Person sx={{ fontSize: 16, marginRight: 1 }} />
                                    {currentCard.farmer}
                                </Typography>
                            </Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>
                                    Generator ID
                                </Typography>
                                <Typography
                                    className={`${classes.detailValue} ${classes.clickableValue}`}
                                    onClick={() => handleUserView(currentCard.generatorID)}
                                >
                                    <Business sx={{ fontSize: 16, marginRight: 1 }} />
                                    {currentCard.generatorID}
                                </Typography>
                            </Box>
                            <Box className={classes.detailItem}>
                                <Typography className={classes.detailLabel}>Status</Typography>
                                <Chip
                                    label={currentCard.status}
                                    color={currentCard.status === 'used' ? 'success' : 'primary'}
                                    icon={
                                        currentCard.status === 'used' ? <CheckCircle /> : <Cancel />
                                    }
                                    size='small'
                                />
                            </Box>
                        </Box>
                    </Box>
                )}

                {/* User Details Dialog */}
                {openAdmin && (
                    <Dialog
                        open={openAdmin}
                        onClose={handlepackagesClose}
                        className={classes.dialog}
                        maxWidth='sm'
                        fullWidth
                    >
                        {adminLoader ? (
                            <Box
                                sx={{ display: 'flex', justifyContent: 'center', padding: '40px' }}
                            >
                                <Spinner />
                            </Box>
                        ) : (
                            <>
                                <DialogTitle className={classes.dialogTitle}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {type === 'admin' ? <Business /> : <Person />}
                                        {type === 'admin' ? 'Admin' : 'Farmer'} Details:{' '}
                                        {admin.name}
                                    </Box>
                                </DialogTitle>
                                <DialogContent sx={{ padding: '0 24px 24px 24px' }}>
                                    <TableContainer component={Paper} sx={{ borderRadius: '12px' }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                                                    <TableCell sx={{ fontWeight: '600' }}>
                                                        Name
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: '600' }}>
                                                        {type === 'admin' ? 'Email' : 'Contact'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: '600' }}>
                                                        {type === 'admin' ? 'Role' : 'Gender'}
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {!adminLoader && Object.keys(admin).length > 0 && (
                                                <TableBody>
                                                    <TableRow
                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: '#f8fafc'
                                                            }
                                                        }}
                                                    >
                                                        <TableCell>{admin.name}</TableCell>
                                                        <TableCell>
                                                            {type === 'admin'
                                                                ? admin.email
                                                                : admin.contact}
                                                        </TableCell>
                                                        <TableCell>
                                                            {type === 'admin'
                                                                ? admin.role
                                                                : admin.gender}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )}
                                        </Table>
                                    </TableContainer>
                                </DialogContent>
                            </>
                        )}
                    </Dialog>
                )}
            </div>
        </div>
    );
}
